var render = function render(){var _vm=this,_c=_vm._self._c;return _c('multiselect',{attrs:{"options":_vm.getOptions,"value":_vm.value,"multiple":"","track-by":"id","label":"option_label","disabled":_vm.isDisabled},on:{"input":_vm.setValue}})
}
var staticRenderFns = []

export { render, staticRenderFns }